export class ServerMessage {
	code: number;
	message: string;
	redirectionURL: string;
	service: string;
	data: any;
}
